let timer;
let arrowStart = 68;
let scaleElementRotate = 38;
let speedometrScaleList = $('.speedometr-scale').children('li');
let franchiseAdvantagesList = $('.franchise-advantages-list').children('li');

$('.speedometr-trigger').on('next click', function (e) {
    e.preventDefault();
    let index = $('.speedometr-trigger').index(this);
    speedometrScaleList.removeClass('active');
    speedometrScaleList.eq(index).addClass('active');
    franchiseAdvantagesList.removeClass('active');
    franchiseAdvantagesList.eq(index).addClass('active');
    let arrowRotate = arrowStart + (scaleElementRotate * index);
    $('.speedometr-arrow').css('transform', 'rotate(' + arrowRotate + 'deg)');
    clearInterval(timer);
    autoSelect(index);
});

function autoSelect(init) {
    let index = init;
    timer = window.setInterval(function () {
        if (++index === 7) index = 0;
        speedometrScaleList.eq(index).children().trigger('next');
    }, 8000);
}

autoSelect(0);